import React from 'react';

export default ({ type, value, className }) => {
	let iconClass, color;

	switch (type) {
		case 'info' : iconClass = 'fa-info-circle'; color = 'grey'; break;
		case 'error' : iconClass = 'fa-exclamation-circle'; color = 'red'; break;
		case 'warning' : iconClass = 'fa-exclamation-circle'; color = 'yellow'; break;
		case 'success' : iconClass = 'fa-check-circle'; color = 'green'; break;
		default : iconClass = 'fa-info-circle'; color = 'grey'; break;
	}

	return (
		<div className={`d-flex align-items-end information-text ${color} ${className}`}>
			<i className={`fas ${iconClass}`}></i> 
			<span>{value}</span>
		</div>
	)
}
